module.exports = __webpack_public_path__ + "static/img/bg_coupon_five.ba54363.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_coupon_five.png
// module id = zGbo
// module chunks = 0